"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var SvgBellFilled = function (props) { return (react_1.default.createElement("svg", __assign({ width: '1em', height: '1em', viewBox: '0 0 24 24' }, props),
    react_1.default.createElement("path", { d: 'M18 16V9.961a5.95 5.95 0 00-4-5.621V4a2 2 0 10-4 0v.362a6.032 6.032 0 00-4 5.677V16H5c-.667 0-1 .333-1 1s.333 1 1 1h14c.667 0 1-.333 1-1s-.333-1-1-1h-1zm-8 4a2 2 0 004 0h-4z' }))); };
exports.default = SvgBellFilled;
//# sourceMappingURL=BellFilled.js.map